import {
  ReciptBridgeAvax,
  ReciptBridgeBsc,
  ReciptBridgeEth,
  ReciptBridgePolygon,
  isMainNet,
} from "./config";

export const NETWORKS_SHORT_NAMES = {
  ETH: "ETH",
  BSC: "BSC",
  POLYGON: "POLYGON",
  AVAX: "AVAX",
};

export const NETWORKS_TESTNET = {
  [NETWORKS_SHORT_NAMES.ETH]: 5,
  [NETWORKS_SHORT_NAMES.BSC]: 97,
  [NETWORKS_SHORT_NAMES.POLYGON]: 80001,
  [NETWORKS_SHORT_NAMES.AVAX]: 43113,
  5: NETWORKS_SHORT_NAMES.ETH,
  97: NETWORKS_SHORT_NAMES.BSC,
  80001: NETWORKS_SHORT_NAMES.POLYGON,
  43113: NETWORKS_SHORT_NAMES.AVAX,
};
export const NETWORKS_MAINNET = {
  [NETWORKS_SHORT_NAMES.ETH]: 1,
  [NETWORKS_SHORT_NAMES.BSC]: 56,
  [NETWORKS_SHORT_NAMES.POLYGON]: 137,
  [NETWORKS_SHORT_NAMES.AVAX]: 43114,
  1: NETWORKS_SHORT_NAMES.ETH,
  56: NETWORKS_SHORT_NAMES.BSC,
  137: NETWORKS_SHORT_NAMES.POLYGON,
  43114: NETWORKS_SHORT_NAMES.AVAX,
};
export const RECEIPT_BRIDGE_CONTRACTS = {
  [NETWORKS_SHORT_NAMES.ETH]: `${ReciptBridgeEth}`,
  [NETWORKS_SHORT_NAMES.BSC]: `${ReciptBridgeBsc}`,
  [NETWORKS_SHORT_NAMES.POLYGON]: `${ReciptBridgePolygon}`,
  [NETWORKS_SHORT_NAMES.AVAX]: `${ReciptBridgeAvax}`,
};

// export const chainId =
//   process.env.REACT_APP_IS_MAINNET === "false"
//     ? NETWORKS_TESTNET.ETH
//     : NETWORKS_MAINNET.ETH;

export const networkName = (chainId) => {
  if (!chainId) return;
  return isMainNet === "true"
    ? NETWORKS_MAINNET[chainId]
    : NETWORKS_TESTNET[chainId];
};

export const domain = {
  name: "BlockPay",
  version: "1",
  // chainId: 1, // Replace with actual chainId
  // verifyingContract: RECEIPT_BRIDGE_CONTRACTS[networkName],
};

export const walletParams = {
  types: {
    EIP712Domain: [
      {
        name: "name",
        type: "string",
      },
      {
        name: "version",
        type: "string",
      },
      {
        name: "chainId",
        type: "uint256",
      },
      {
        name: "verifyingContract",
        type: "address",
      },
    ],
    Auth: [
      {
        name: "address",
        type: "address",
      },
      {
        name: "nonce",
        type: "uint256",
      },
    ],
  },
  primaryType: "Auth",
  domain,
};

export const timeframe = [
  {
    value: "Day",
  },
  {
    value: "Week",
  },
  {
    value: "Month",
  },
  // {
  //   value: "Year",
  // },
];
export const statsType = [
  {
    value: "Revenue",
    key: "revenue",
  },
  // {
  //   value: "Portfolio",
  //   key: "portfolio",
  // },
  // {
  //   value: "Market",
  //   key: "market",
  // },
];
export const Networks = {
  BSC: "Binance",
  ETH: "Ethereum",
  AVAX: "Avalanche",
  POLYGON: "Polygon",
  Binance: "BSC",
  Ethereum: "ETH",
  Avalanche: "AVAX",
  Polygon: "POLYGON",
};

export const networkIcons = {
  BSC: "/images/networks/binance.svg",
  ETH: "/images/networks/eth.svg",
  AVAX: "/images/networks/avalanche.svg",
  POLYGON: "/images/networks/polygon.svg",
  Binance: "/images/networks/binance.svg",
  Ethereum: "/images/networks/eth.svg",
  Avalanche: "/images/networks/avalanche.svg",
  Polygon: "/images/networks/polygon.svg",
};
export const tokenIcons = {
  BUSD: "/images/networks/binance.svg",
  USDT: "/images/tokens/tether.svg",
  USDC: "/images/tokens/USDC.svg",
  DAI: "/images/tokens/DAI.svg",
};
export const csvHeader = [
  { label: "Amount", key: "amountUsd" },
  { label: "Token", key: "token" },
  { label: "Blockchain", key: "blockchain" },
  { label: "Creation Date", key: "createdAt" },
  { label: "Expiry Date", key: "paymentDate" },
  { label: "Status", key: "status" },
  { label: "NFT Link", key: "nftLink" },
  { label: "TxLink", key: "txLink" },
  { label: "Invoice Link", key: "invoiceLink" },
];
